
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19.832 46.545"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a","transform":"translate(.797 11.661)"}},[_c('circle',{attrs:{"cx":"9.184","cy":"9.184","r":"9.119","fill":"none"}})])]),_c('g',{attrs:{"data-name":"レイヤー 2"}},[_c('g',{attrs:{"data-name":"レイヤー 1","fill":"#ec7700"}},[_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M.025 20.096L19.597.054a.13.13 0 01.183-.029.131.131 0 01.029.183L.237 20.25a.13.13 0 01-.183.029.13.13 0 01-.029-.183zM.025 25.344L19.597 5.302a.132.132 0 01.183-.029.132.132 0 01.029.184L.237 25.499a.131.131 0 01-.183.028.13.13 0 01-.029-.183zM.025 30.592L19.597 10.55a.131.131 0 01.183-.028.131.131 0 01.029.183L.237 30.747a.132.132 0 01-.183.029.131.131 0 01-.029-.184zM.025 35.84l19.572-20.041a.131.131 0 01.212.154L.237 35.995a.131.131 0 01-.183.029.131.131 0 01-.029-.184zM.025 41.089l19.572-20.042a.131.131 0 01.212.154L.237 41.243a.13.13 0 01-.183.029.13.13 0 01-.029-.183zM.025 46.337l19.572-20.042a.131.131 0 01.183-.029.132.132 0 01.029.184L.237 46.491a.13.13 0 01-.183.029.13.13 0 01-.029-.183z"}})]),_c('path',{attrs:{"d":"M10.047 30.161a9.25 9.25 0 119.25-9.25 9.261 9.261 0 01-9.25 9.25zm0-18.238a8.988 8.988 0 108.988 8.988 9 9 0 00-8.988-8.988z"}})])])])
          )
        }
      }
    